import i18n from "../../../i18n";
import moment from "moment";

export const newsFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("news.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "type",
        label: i18n.t("news.type"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "fromDate",
        label: i18n.t("news.fromDate"),
        formatter: formatDate
    },
    {
        key: "toDate",
        label: i18n.t("news.toDate"),
        formatter: formatDate
    },
    {
        key: "actions",
        label: ""
    }
];

function formatDate(dateTime: string) {
    if (dateTime) {
        return new Date(dateTime).toLocaleString("en-US", { year: "numeric", month: "long", day: "numeric" });
    }
    return "";
}
